import { CheckBox as Check, CheckBoxExtendedProps } from 'grommet'
import { ReactNode, useState } from 'react'

interface Props extends CheckBoxExtendedProps {
  defaultCheck?: boolean | string
  label?: string | ReactNode
  handleChange: (arg: boolean) => void
  /** When provided, component is controlled and always reflects this value */
  checked?: boolean
}

export const CheckBox = ({ defaultCheck, label, handleChange, checked: checkedProp, ...rest }: Props) => {
  const [uncontrolled, setUncontrolled] = useState(defaultCheck || false)
  const isControlled = checkedProp !== undefined
  const checked = isControlled ? !!checkedProp : !!uncontrolled

  return (
    <Check
      checked={checked}
      label={label}
      onChange={event => {
        const next = event.target.checked
        if (!isControlled) setUncontrolled(next)
        handleChange(next)
      }}
      {...rest}
    />
  )
}
